export const strings = {
  INVALID_TYPE: "Please upload an image file",
  MAX_SIZE: "File size should not exceed 5MB",
  CLICK_CHANGE: "Click or drag to change logo",
  CLICK_UPLOAD: "Click to upload or drag and drop",
  SUPPORTED_FORMAT: "PNG, JPG, GIF up to 5MB",
  SHOWING: "Showing",
  TO: "to",
  OF: "of",
  RESULTS: "results",
  DESCRIPTION: "Complete details and information",
  CLOSE: "Close",
  PROFILE: "My Profile",
  LOGOUT: "Logout",
  DARK: "Dark Mode",
  LIGHT: "Light Mode",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  FROZEN: "Frozen",
  VIEW: "View",
  EDIT: "Edit",
  FREEZE: "Freeze",
  UNFREEZE: "Unfreeze",
  DELETE: "Delete",
  DASHBOARD: "Dashboard",
  FOOTER_COPYRIGHT: "© {year} Object Infotech. All rights reserved.",
  LOGIN_TITLE: "Welcome back",
  LOGIN_SUBTITLE: "Sign in to your account",
  EMAIL_LABEL: "Email",
  EMAIL_PLACEHOLDER: "you@example.com",
  BUTTON_CONTINUE: "Continue",
  BUTTON_LOADING: "Sending OTP...",
  ERROR_SEND_OTP: "Failed to send OTP. Please try again.",
  VERIFY_OTP_TITLE: "Verify OTP",
  VERIFY_OTP_SUBTITLE: "Enter the 6-digit code sent to",
  BUTTON_VERIFY: "Verify",
  BUTTON_VERIFYING: "Verifying...",
  RESEND_TEXT: "Resend code in",
  ERROR_INVALID_OTP: "Invalid OTP. Please try again.",
  ERROR_RESEND_OTP: "Failed to resend OTP. Please try again.",
  SUPER_ADMIN_PANEL: "Super Admin Panel",
  VIEW_DETAILS: "View Details",
  EDIT_COMPANY: "Edit Company",
  DELETE_COMPANY: "Delete Company",
  FREEZE_COMPANY: "Freeze Company",
  UNFREEZE_COMPANY: "Unfreeze Company",
  ALL_STATUS: "All Status",
  SEARCH_PLACEHOLDER: "Search companies...",
  NEWEST_FIRST: "Newest First",
  ONE_COLUMN: "One column",
  TWO_COLUMNS: "Two columns",
  THREE_COLUMNS: "Three columns",
  OLDEST_FIRST: "Oldest First",
  THEREARE: "There are",
  COMPANIES: "companies",
  ADD_COMPANY: "Add Company",
  DELETE_TITLE: "Delete Company",
  FREEZE_TITLE: "Freeze Company",
  UNFREEZE_TITLE: "Unfreeze Company",
  DELETE_MESSAGE: (name) => `Are you sure you want to delete "${name}"?`,
  FREEZE_MESSAGE: (name) => `Are you sure you want to freeze "${name}"? Users won't be able to access this company.`,
  UNFREEZE_MESSAGE: (name) => `Are you sure you want to unfreeze "${name}"? Users will regain access.`,
  COMPANEE_MANAGEMENT: "Company Management",
  COMPANY_MANAGEMENT: "Company Management",
  DASHBOARD_DESCRIPTION: "Overview of your organization's performance, statistics, and system activity.",
  COMPANY_DESCRIPTION: "Manage, monitor, and configure all registered companies across the platform.",
  ANNOUNCEMENT_DESCRIPTION: "Stay updated with what's happening in your organization.",
  CONTACT_REQUEST_DESCRIPTION: "Manage and respond to inquiries from the contact form.",
  BRANDS_DESCRIPTION: "Manage company brands, client logos, and brand partnerships.",
  REVIEWS_DESCRIPTION: "View, moderate, and manage client testimonials and feedback.",
  BLOG_DESCRIPTION: "Publish articles, track reader engagement, and manage your editorial workflow.",
  SETTINGS_DESCRIPTION: "Manage system configurations and application preferences.",
  ADMIN_MONITORING_TITLE: "Super Admin Login Monitoring",
  LAST_LOGIN: "Last Login:",
  TODAY_AT: "Today at",
  LOGINS_THIS_WEEK: "Logins this Week:",
  QUICK_ACTION_TITLE: "Quick Actions",
  SEARCH_COMPANY: "Search Company",
  RECENT_ACTIVITY_TITLE: "Recent System Activity",
  RECENT_ACTIVITY: "Last Activity",
  VIEW_ALL_ACTIVITY: "View All Activity →",
  BY: "by",
  MY_PROFILE: "My Profile",
  PROFILE_DESCRIPTION: "Manage your personal information",
  EDIT_PROFILE: "Edit Profile",
  SAVE_CHANGES: "Save Changes",
  CANCEL: "Cancel",
  UPLOAD_PHOTO: "Upload Photo",
  SUPPORTED_FORMATS: "Supported formats: PNG, JPG, GIF (max 5MB)",
  PERSONAL_INFORMATION: "Personal Information",
  FIRAT_NAME: "First Name",
  LAST_NAME: "Last Name",
  EMAIL: "Email",
  PHONE: "Phone Number",
  USERNAME: "Username",
  USERNAME_CANNOT_BE_CHANGED: "Username cannot be changed",
  EMAIL_CANNOT_BE_CHANGED: "Email address cannot be changed",
  CONTACT_INFORMATION: "Contact Information",
  MOBILE_NUMBER: "Mobile Number",
  MOBILE_NUMBER_CANNOT_BE_CHANGED: "Mobile number cannot be changed",
  ROLE: "Role",
  SUPER_ADMIN_ADMINISTER: "Super Administrator",
  SUSPENDED: "Suspended",
  NO_RECENT_ACTIVITY_TITLE: "No recent activities",

  // Announcement Management
  ANNOUNCEMENT_MANAGEMENT: "Announcement Management",
  ADD_ANNOUNCEMENT: "Add Announcement",
  EDIT_ANNOUNCEMENT: "Edit Announcement",
  DELETE_ANNOUNCEMENT_TITLE: "Delete Announcement",
  DELETE_ANNOUNCEMENT_MESSAGE: (title) => `Are you sure you want to delete "${title}"? `,
  ANNOUNCEMENT_TITLE: "Title",
  SELECT_COMPANIES: "Select Companies",
  SEARCH_ANNOUNCEMENTS: "Search announcements...",
  NO_ANNOUNCEMENTS: "No announcements yet",
  NO_ANNOUNCEMENTS_FOUND: "No announcements found",
  CREATE_FIRST_ANNOUNCEMENT: "Create First Announcement",
  ALL_USERS: "All Users",
  ALL_EMPLOYEES: "All Employees",
  ALL_COMPANIES: "All Companies",
  UNKNOWN_TARGET: "Unknown Target",
  BASIC_INFORMATION: "Basic Information",
  ADDRESS_INFORMATION: " Address Information",
  COMPANY_DETAILS: "Company Details",
  NO_COMPANIES_FOUND: "No companies found",
  // Announcement Modal Strings
  ANNOUNCEMENT_MODAL_TITLE: "Add New Announcement",
  ANNOUNCEMENT_TITLE_LABEL: "Title *",
  ANNOUNCEMENT_TITLE_PLACEHOLDER: "Enter announcement title",
  ANNOUNCEMENT_MESSAGE_LABEL: "Message *",
  ANNOUNCEMENT_MESSAGE_PLACEHOLDER: "Enter announcement message",
  ANNOUNCEMENT_SEND_TO: "Send To",

  ANNOUNCEMENT_ALL_USERS: "All Users",
  ANNOUNCEMENT_ALL_USERS_DESC: "Send to all users in the system",

  ANNOUNCEMENT_ALL_COMPANIES: "All Companies",
  ANNOUNCEMENT_ALL_COMPANIES_DESC: "Send to all registered companies",

  ANNOUNCEMENT_ALL_EMPLOYEES: "All Employees",
  ANNOUNCEMENT_ALL_EMPLOYEES_DESC: "Send to all company employees",

  ANNOUNCEMENT_CREATE_BUTTON: "Create Announcement",
  ANNOUNCEMENT_DELETE: "Delete",
  ANNOUNCEMENT_DELETE_ALL: "Delete All",

  // Validation
  ERROR_TITLE_REQUIRED: "Title is required",
  ERROR_MESSAGE_REQUIRED: "Message is required",

  EMPTY_ANNOUNCEMENT_TITLE: "No Announcements Yet",
  EMPTY_ANNOUNCEMENT_DESCRIPTION:
    "Get started by creating your first announcement to communicate with users, companies, and employees.",
  EMPTY_ANNOUNCEMENT_BUTTON: "Create Announcement",
  TOTAL_COMPANIES: "Total Companies",
  ACTIVE_COMPANIES: "Active Companies",
  SUSPENDED_COMPANIES: "Suspended Companies",
  COMPANYNAME_PLACEHOLDER: "Enter company name",
  COMPANEEEMAIL_PLACEHOLDER: "Enter company email",
  MOBILENIMBER_PLACEHOLDER: "Enter mobile number",
  ADDRESS_PLACEHOLDER: "Enter company address",
  CITY_PLACEHOLDER: "Enter city",
  STATE_PLACEHOLDER: "Enter state",
  COUNTRY_PLACEHOLDER: "Enter country",
  ZIPCODE_PLACEHOLDER: "Enter zip code",
  INDUSTRY_PLACEHOLDER: "Enter industry name",
  GST_PLACEHOLDER: "Enter GST number",
  COMPANY_WEBSITE_PLACEHOLDER: "Enter company website URL",
  NOT_ADDED: "N/A",
  REASON_FOR_FREEZING: "Reason for freezing",
  FREEZE_REASON_PLACEHOLDER: "Please provide a detailed reason for freezing this company...",
  FREEZE_REASON_DESCRIPTION: "This reason will be recorded and visible in the company's activity log.",
  UNFREEZE_MESSAGE_DESCRIPTION: "Unfreezing will restore full access to the company and all its users.",
  NOTE: "Note:",
  ADD_NEW_COMPANY: "Add New Company",
  UPDATE_COMPANY_INFO: "Update company information below",
  COMPLETE_FORM_REGISTER: "Complete the form to register a new company",
  COMPANY_NAME_LABEL: "Company Name",
  COMPANY_CODE_LABEL: "Company Code",
  COMPANY_CODE_PLACEHOLDER: "Enter company code",
  COMPANY_EMAIL_LABEL: "Company Email",
  ADDRESS_LINE_1_LABEL: "Address Line 1",
  ADDRESS_LINE_2_LABEL: "Address Line 2",
  CITY_LABEL: "City",
  STATE_LABEL: "State",
  COUNTRY_LABEL: "Country",
  ZIP_CODE_LABEL: "Zip Code",
  COMPANY_LOGO_LABEL: "Company Logo",
  COMPANY_WEBSITE_LABEL: "Company Website",
  INDUSTRY_LABEL: "Industry",
  COMPANY_SIZE_LABEL: "Company Size",
  SELECT_COMPANY_SIZE: "Select company size",
  EMPLOYEES_SUFFIX: "employees",
  GST_NUMBER_LABEL: "GST Number",
  UPDATING: "Updating...",
  ADDING: "Adding...",
  UPDATE_COMPANY: "Update Company",
  NO_CHANGES_DETECTED: "No changes detected",
  // Contact Request Management
  CONTACT_REQUEST_MANAGEMENT: "Contact Requests",
  DELETE_CONTACT_TITLE: "Delete Request",
  DELETE_CONTACT_MESSAGE: (name) => `Are you sure you want to delete the request from "${name}"?`,
  NO_CONTACT_REQUESTS: "No contact requests yet",
  SEARCH_CONTACTS: "Search requests...",
  CONTACT_NAME: "Name",
  CONTACT_EMAIL: "Email",
  CONTACT_PHONE: "Phone",
  CONTACT_SUBJECT: "Subject",
  CONTACT_MESSAGE: "Message",
  CONTACT_DATE: "Date",
  CONTACT_COMPANY: "Company",
  CONTACT_SOURCE: "Source",
  CONTACT_EMPLOYEE_COUNT: "Employee Count",
  CONTACT_DETAILS: "Request Details",
  CONTACT_MARK_RESOLVED: "Mark as Resolved",
  CONTACT_RESOLVED: "Resolved",
  perPage: "Per Page",
  total: "Total",
  previousPage: "Previous Page",
  nextPage: "Next Page",
  OBJECT_INFOTECH: "PeopleSync",
  HRMS_PLATFORM: "Keep Your People in Sync",
  PLATFORM_COMMAND_CENTER: "Super Admin Portal",
  ENTERPRISE_HR_OPERATIONS: "Centralized Platform",
  UNIFIED: "Management.",
  HERO_DESCRIPTION:
    "Effortlessly manage active companies, broadcast announcements, oversee brands and reviews, and monitor contact requests from a unified dashboard.",
  TENANT_DIRECTORY: "Tenant Directory",
  BROADCAST_SYSTEM: "Broadcast System",
  SERVICE_DESK: "Service Desk",
  SECURITY_AUDITS: "Security Audits",
  SUPER_ADMIN_PORTAL: "Super Admin Portal",
  ACCESS_CONTROL_CENTER: "Access your Peoplesync control center",
  ALL_RIGHTS_RESERVED: "All rights reserved.",
  EMAIL_ADDRESS_LABEL: "Email Address",
  EMAIL_INPUT_PLACEHOLDER: "Enter your email",
  BUTTON_CONTINUE_EMAIL: "Continue with Email",
  SECURE_LOGIN_TEXT: "Secure OTP Login",
  RESEND_OTP_TEXT: "Resend OTP in",
  DIDNT_RECEIVE_CODE: "Didn't receive the code?",
  SENDING_TEXT: "Sending…",
  RESEND_CODE: "Resend Code",
  VERIFY_LOGIN_TEXT: "Verify & Login",
  BACK_TO_EMAIL: "Back to Email",

  // Brands Management
  BRANDS_MANAGEMENT: "Brands Management",
  ADD_BRAND: "Add Brand",
  EDIT_BRAND: "Edit Brand",
  DELETE_BRAND: "Delete Brand",
  BRAND_NAME: "Brand Name",
  BRAND_NAME_PLACEHOLDER: "Enter brand name",
  BRAND_DESCRIPTION: "Description",
  BRAND_DESCRIPTION_PLACEHOLDER: "Enter brand description",
  BRAND_LOGO: "Brand Logo",
  NO_BRANDS_YET: "No brands yet",
  SEARCH_BRANDS: "Search brands...",
  DELETE_BRAND_TITLE: "Delete Brand",
  DELETE_BRAND_MESSAGE: (name) => `Are you sure you want to delete "${name}"?`,

  // Reviews Management
  REVIEWS_MANAGEMENT: "Reviews Management",
  ADD_REVIEW: "Add Review",
  EDIT_REVIEW: "Edit Review",
  DELETE_REVIEW: "Delete Review",
  REVIEWER_NAME: "Reviewer Name",
  REVIEWER_NAME_PLACEHOLDER: "Enter reviewer name",
  REVIEW_CONTENT: "Review Content",
  REVIEW_CONTENT_PLACEHOLDER: "Enter review content",
  RATING: "Rating",
  REVIEWER_IMAGE: "Reviewer Image",
  DESIGNATION: "Designation",
  DESIGNATION_PLACEHOLDER: "Enter designation",
  STATUS: "Status",
  NO_REVIEWS_YET: "No reviews yet",
  SEARCH_REVIEWS: "Search reviews...",
  DELETE_REVIEW_TITLE: "Delete Review",
  DELETE_REVIEW_MESSAGE: (name) => `Are you sure you want to delete the review by "${name}"?`,

  // Blog Management
  BLOG: "Blog",
  BLOG_MANAGEMENT: "Blog",
  ADD_BLOG: "Add Blog",
  EDIT_BLOG: "Edit Blog",
  DELETE_BLOG: "Delete Blog",
  SEARCH_BLOGS: "Search blogs...",
  NO_BLOGS_YET: "No blogs yet",
  BLOG_TITLE: "Blog Title",
  BLOG_TITLE_PLACEHOLDER: "Enter blog title",
  BLOG_SLUG: "Slug / URL",
  BLOG_SLUG_PLACEHOLDER: "enter-blog-slug",
  BLOG_CATEGORY: "Category",
  BLOG_CATEGORY_PLACEHOLDER: "Enter category (e.g. HR Tips, Payroll, Culture)",
  KEYWORDS: "Keywords",
  KEYWORDS_PLACEHOLDER: "Enter keywords (comma separated, e.g. HR, payroll, retention)",
  BLOG_AUTHOR: "Author",
  BLOG_AUTHOR_PLACEHOLDER: "Enter author name",
  BLOG_IMAGE: "Blog Image / Banner",
  BLOG_CONTENT: "Description / Content",
  BLOG_CONTENT_PLACEHOLDER: "Enter blog content...",
  META_DESCRIPTION: "Meta Description (for SEO)",
  META_DESCRIPTION_PLACEHOLDER: "Brief summary for search engine snippet...",
  DELETE_BLOG_TITLE: "Delete Blog",
  DELETE_BLOG_MESSAGE: (title) => `Are you sure you want to delete "${title}"?`,
};
